// ------------------------------------
// Zoom
// ------------------------------------
(function () {
  "use strict";
  $(".img-zoom").zoom({
    magnify: 1.5,
  });
})();
